module.exports = __webpack_public_path__ + "static/media/poste_3.87f56755.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_3.jpg
// module id = 259
// module chunks = 0